module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteLot":"Delete Lot","deleteLotText":"Are you sure you want to delete this Lot ?"},"al":{"deleteLot":"Fshi Lot","deleteLotText":"A jeni i sigurt se dëshironi të fshini këtë Lot ?"}}')
  delete Component.options._Ctor
}
